import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs/Rx';
import { CookieService } from 'ngx-cookie-service';
import { APIConstants } from '../app.constants';
import { map } from 'rxjs/operators';
import { ExternalRouterService } from './external-router.service';
import { Utils } from '../Utils';

@Injectable({
  providedIn: 'root'
})
export class CouponService {
  private _coupons:Subject<any> = new Subject<any>();
  public readonly coupons$ = this._coupons.asObservable();
  readonly url = APIConstants.BASE_URL

  constructor(
    private httpClient: HttpClient,
    private _cookie: CookieService,
    private _externalService: ExternalRouterService
  ) { }
  callcoupon(cartId: string, coupon: string) {
    console.log("inside coupon service")
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization':this._cookie.get("Authorization")
    })
  
     return this.httpClient.put<any>(
    `${this.url}/cart/apply-coupon?cartId=${cartId}&couponCode=${coupon}`,
    {},
    { headers }
  );
   
  }
  removeCoupon(cartId: string) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization':this._cookie.get("Authorization")
    })
    let options = { headers: headers };
    return this.httpClient.delete<any>(this.url + "/cart/remove-coupon?cartId=" + cartId, options)
  }

  getPublicCoupon() {
    return this.httpClient.get<any>(this.url + "/coupon/public");
  }
  createCoupon(body, Authorization) {
    const url = this.url+"/contact/sendContactForm";
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization
    });
    body.description = body.description == null? '': body.description +" Landing Page: " + this._externalService.getUrl()[0];
    return this.httpClient.post<any>(url+'?query=https://wa.me/917217760961?text='+Utils.getWhatAppHiiText(), body, { headers });
  }

  emit(publicCoupons){
    this._coupons.next(publicCoupons)
  }
}